import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { adminApi } from "../../lib/adminApi";
import { useConfig } from "../../context/BrandContext";
import { Card, PageTitle, Btn } from "../../components/admin/AdminUI";
import { ShipmentRows } from "./Dashboard";

export default function Shipments() {
  const { statuses } = useConfig();
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const status = params.get("status") || "";
  const page = Number(params.get("page") || 1);
  const [data, setData] = useState(null);

  const update = (patch) => {
    const next = new URLSearchParams(params);
    Object.entries(patch).forEach(([k, v]) => (v ? next.set(k, v) : next.delete(k)));
    setParams(next, { replace: true });
  };

  useEffect(() => {
    const t = setTimeout(() => { if (q !== (params.get("q") || "")) update({ q, page: "" }); }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  useEffect(() => {
    adminApi.get("/admin/shipments", { params: { q: params.get("q") || "", status, page, page_size: 20 } }).then((r) => setData(r.data));
  }, [params, status, page]);

  return (
    <div data-testid="admin-shipments">
      <PageTitle eyebrow="Operations" title="Shipments" />
      <Card>
        <div className="flex flex-col sm:flex-row gap-3 mb-5">
          <div className="relative flex-1">
            <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search tracking #, name, email or phone" data-testid="shipments-search-input"
              className="w-full h-10 pl-9 pr-3 border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500" />
          </div>
          <select value={status} onChange={(e) => update({ status: e.target.value, page: "" })} data-testid="shipments-status-filter"
            className="h-10 px-3 border border-slate-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-amber-500">
            <option value="">All statuses</option>
            {[...statuses, "Cancelled"].map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        {!data ? <p className="text-slate-500 text-sm">Loading…</p> : (
          <>
            <ShipmentRows items={data.items} />
            <div className="mt-5 flex items-center justify-between text-sm text-slate-600">
              <span data-testid="shipments-total">{data.total} shipment{data.total === 1 ? "" : "s"} · page {data.page} of {data.pages}</span>
              <div className="flex gap-2">
                <Btn variant="ghost" disabled={page <= 1} onClick={() => update({ page: String(page - 1) })} data-testid="shipments-prev-page">Prev</Btn>
                <Btn variant="ghost" disabled={page >= data.pages} onClick={() => update({ page: String(page + 1) })} data-testid="shipments-next-page">Next</Btn>
              </div>
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
